export default __webpack_public_path__ + "static/Lato-Light-bfc37ff1d5543ecd4ec661f4ab38622e.ttf";